// @flow
export const UNLOADED: string = "UNLOADED";
export const LOADING: string = "LOADING";
export const LOADED: string = "LOADED";
export const NONE: string = "NONE";
export const ERROR: string = "ERROR";
export const SUCCESS: string = "SUCCESS";
export const PENDING: string = "PENDING";
export const READY: string = "READY";
